import React from 'react';
import { createPortal } from 'react-dom';
import type { AssignmentRewardProcessResult } from '../../utils/assignmentRewardSync';

type Props = {
  open: boolean;
  title?: string;
  result: AssignmentRewardProcessResult | null;
  onClose: () => void;
};

const AssignmentRewardResultModal: React.FC<Props> = ({
  open,
  title = '과제 보상 처리 결과',
  result,
  onClose,
}) => {
  if (!open || !result) return null;

  return createPortal(
    <div className="cp-apn-reward-result-overlay" role="presentation" onClick={onClose}>
      <div
        className="cp-apn-reward-result-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cp-apn-reward-result-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="cp-apn-reward-result-title" className="cp-apn-reward-result-title">
          {title}
        </h2>

        <div className="cp-apn-reward-result-summary">
          <p>
            보상지급 <strong>{result.grantedCount}</strong>명
            {result.revokedCount > 0 ? (
              <>
                {', '}
                회수 <strong>{result.revokedCount}</strong>명
              </>
            ) : null}
          </p>
          <p>
            총 보상지급자 수: <strong>{result.holderMembers.length}</strong>명
          </p>
          {result.grantedCount === 0 && result.revokedCount === 0 ? (
            <p className="cp-apn-reward-result-hint">
              보상 조건을 충족한 멤버가 없습니다. 도달률을 확인한 뒤 다시 시도해 주세요.
            </p>
          ) : null}
        </div>

        <div className="cp-apn-reward-result-section">
          <h3 className="cp-apn-reward-result-section-title">
            이번에 보상받은 멤버 ({result.newlyGrantedMembers.length})
          </h3>
          {result.newlyGrantedMembers.length === 0 ? (
            <p className="cp-apn-reward-result-empty">새로 지급된 멤버가 없습니다.</p>
          ) : (
            <ul className="cp-apn-reward-result-list">
              {result.newlyGrantedMembers.map((m) => (
                <li key={m.memberId}>{m.label}</li>
              ))}
            </ul>
          )}
        </div>

        {result.revokedMembers.length > 0 ? (
          <div className="cp-apn-reward-result-section">
            <h3 className="cp-apn-reward-result-section-title">
              이번에 회수된 멤버 ({result.revokedMembers.length})
            </h3>
            <ul className="cp-apn-reward-result-list">
              {result.revokedMembers.map((m) => (
                <li key={m.memberId}>{m.label}</li>
              ))}
            </ul>
          </div>
        ) : null}

        <div className="cp-apn-reward-result-section">
          <h3 className="cp-apn-reward-result-section-title">
            현재 보상 지급 완료 멤버 ({result.holderMembers.length})
          </h3>
          {result.holderMembers.length === 0 ? (
            <p className="cp-apn-reward-result-empty">보상 지급 완료 멤버가 없습니다.</p>
          ) : (
            <ul className="cp-apn-reward-result-list">
              {result.holderMembers.map((m) => (
                <li key={m.memberId}>{m.label}</li>
              ))}
            </ul>
          )}
        </div>

        <div className="cp-apn-reward-result-footer">
          <button type="button" className="cp-apn-reward-result-ok" onClick={onClose}>
            확인
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AssignmentRewardResultModal;
